"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _ItemBoundable = _interopRequireDefault(require("./ItemBoundable"));

var _PriorityQueue = _interopRequireDefault(require("../../util/PriorityQueue"));

var _hasInterface = _interopRequireDefault(require("../../../../../hasInterface"));

var _SpatialIndex = _interopRequireDefault(require("../SpatialIndex"));

var _AbstractNode2 = _interopRequireDefault(require("./AbstractNode"));

var _Double = _interopRequireDefault(require("../../../../../java/lang/Double"));

var _Collections = _interopRequireDefault(require("../../../../../java/util/Collections"));

var _BoundablePair = _interopRequireDefault(require("./BoundablePair"));

var _ArrayList = _interopRequireDefault(require("../../../../../java/util/ArrayList"));

var _Comparator = _interopRequireDefault(require("../../../../../java/util/Comparator"));

var _Serializable = _interopRequireDefault(require("../../../../../java/io/Serializable"));

var _Envelope = _interopRequireDefault(require("../../geom/Envelope"));

var _Assert = _interopRequireDefault(require("../../util/Assert"));

var _AbstractSTRtree2 = _interopRequireDefault(require("./AbstractSTRtree"));

var _ItemDistance = _interopRequireDefault(require("./ItemDistance"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _get(target, property, receiver) { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get; } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(receiver); } return desc.value; }; } return _get(target, property, receiver || target); }

function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var STRtree =
/*#__PURE__*/
function (_AbstractSTRtree) {
  _inherits(STRtree, _AbstractSTRtree);

  function STRtree() {
    var _this;

    _classCallCheck(this, STRtree);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(STRtree).call(this));
    STRtree.constructor_.apply(_assertThisInitialized(_this), arguments);
    return _this;
  }

  _createClass(STRtree, [{
    key: "createParentBoundablesFromVerticalSlices",
    value: function createParentBoundablesFromVerticalSlices(verticalSlices, newLevel) {
      _Assert.default.isTrue(verticalSlices.length > 0);

      var parentBoundables = new _ArrayList.default();

      for (var i = 0; i < verticalSlices.length; i++) {
        parentBoundables.addAll(this.createParentBoundablesFromVerticalSlice(verticalSlices[i], newLevel));
      }

      return parentBoundables;
    }
  }, {
    key: "createNode",
    value: function createNode(level) {
      return new STRtreeNode(level);
    }
  }, {
    key: "size",
    value: function size() {
      if (arguments.length === 0) {
        return _get(_getPrototypeOf(STRtree.prototype), "size", this).call(this);
      } else return _get(_getPrototypeOf(STRtree.prototype), "size", this).apply(this, arguments);
    }
  }, {
    key: "insert",
    value: function insert() {
      if (arguments.length === 2 && arguments[1] instanceof Object && arguments[0] instanceof _Envelope.default) {
        var itemEnv = arguments[0],
            item = arguments[1];

        if (itemEnv.isNull()) {
          return null;
        }

        _get(_getPrototypeOf(STRtree.prototype), "insert", this).call(this, itemEnv, item);
      } else return _get(_getPrototypeOf(STRtree.prototype), "insert", this).apply(this, arguments);
    }
  }, {
    key: "getIntersectsOp",
    value: function getIntersectsOp() {
      return STRtree.intersectsOp;
    }
  }, {
    key: "verticalSlices",
    value: function verticalSlices(childBoundables, sliceCount) {
      var sliceCapacity = Math.trunc(Math.ceil(childBoundables.size() / sliceCount));
      var slices = new Array(sliceCount).fill(null);
      var i = childBoundables.iterator();

      for (var j = 0; j < sliceCount; j++) {
        slices[j] = new _ArrayList.default();
        var boundablesAddedToSlice = 0;

        while (i.hasNext() && boundablesAddedToSlice < sliceCapacity) {
          var childBoundable = i.next();
          slices[j].add(childBoundable);
          boundablesAddedToSlice++;
        }
      }

      return slices;
    }
  }, {
    key: "query",
    value: function query() {
      if (arguments.length === 1) {
        var searchEnv = arguments[0];
        return _get(_getPrototypeOf(STRtree.prototype), "query", this).call(this, searchEnv);
      } else if (arguments.length === 2) {
        var _searchEnv = arguments[0],
            visitor = arguments[1];

        _get(_getPrototypeOf(STRtree.prototype), "query", this).call(this, _searchEnv, visitor);
      }
    }
  }, {
    key: "getComparator",
    value: function getComparator() {
      return STRtree.yComparator;
    }
  }, {
    key: "createParentBoundablesFromVerticalSlice",
    value: function createParentBoundablesFromVerticalSlice(childBoundables, newLevel) {
      return _get(_getPrototypeOf(STRtree.prototype), "createParentBoundables", this).call(this, childBoundables, newLevel);
    }
  }, {
    key: "remove",
    value: function remove() {
      if (arguments.length === 2 && arguments[1] instanceof Object && arguments[0] instanceof _Envelope.default) {
        var itemEnv = arguments[0],
            item = arguments[1];
        return _get(_getPrototypeOf(STRtree.prototype), "remove", this).call(this, itemEnv, item);
      } else return _get(_getPrototypeOf(STRtree.prototype), "remove", this).apply(this, arguments);
    }
  }, {
    key: "depth",
    value: function depth() {
      if (arguments.length === 0) {
        return _get(_getPrototypeOf(STRtree.prototype), "depth", this).call(this);
      } else return _get(_getPrototypeOf(STRtree.prototype), "depth", this).apply(this, arguments);
    }
  }, {
    key: "createParentBoundables",
    value: function createParentBoundables(childBoundables, newLevel) {
      _Assert.default.isTrue(!childBoundables.isEmpty());

      var minLeafCount = Math.trunc(Math.ceil(childBoundables.size() / this.getNodeCapacity()));
      var sortedChildBoundables = new _ArrayList.default(childBoundables);

      _Collections.default.sort(sortedChildBoundables, STRtree.xComparator);

      var verticalSlices = this.verticalSlices(sortedChildBoundables, Math.trunc(Math.ceil(Math.sqrt(minLeafCount))));
      return this.createParentBoundablesFromVerticalSlices(verticalSlices, newLevel);
    }
  }, {
    key: "nearestNeighbour",
    value: function nearestNeighbour() {
      if (arguments.length === 1) {
        if ((0, _hasInterface.default)(arguments[0], _ItemDistance.default)) {
          var itemDist = arguments[0];
          var bp = new _BoundablePair.default(this.getRoot(), this.getRoot(), itemDist);
          return this.nearestNeighbour(bp);
        } else if (arguments[0] instanceof _BoundablePair.default) {
          var initBndPair = arguments[0];
          return this.nearestNeighbour(initBndPair, _Double.default.POSITIVE_INFINITY);
        }
      } else if (arguments.length === 2) {
        if (arguments[0] instanceof STRtree && (0, _hasInterface.default)(arguments[1], _ItemDistance.default)) {
          var tree = arguments[0],
              _itemDist = arguments[1];
          var bp = new _BoundablePair.default(this.getRoot(), tree.getRoot(), _itemDist);
          return this.nearestNeighbour(bp);
        } else if (arguments[0] instanceof _BoundablePair.default && typeof arguments[1] === "number") {
          var _initBndPair = arguments[0],
              maxDistance = arguments[1];
          var distanceLowerBound = maxDistance;
          var minPair = null;
          var priQ = new _PriorityQueue.default();
          priQ.add(_initBndPair);

          while (!priQ.isEmpty() && distanceLowerBound > 0.0) {
            var bndPair = priQ.poll();
            var currentDistance = bndPair.getDistance();
            if (currentDistance >= distanceLowerBound) break;

            if (bndPair.isLeaves()) {
              distanceLowerBound = currentDistance;
              minPair = bndPair;
            } else {
              bndPair.expandToQueue(priQ, distanceLowerBound);
            }
          }

          return [minPair.getBoundable(0).getItem(), minPair.getBoundable(1).getItem()];
        } else if (arguments[0] instanceof _BoundablePair.default && Number.isInteger(arguments[1])) {
          var _initBndPair2 = arguments[0],
              k = arguments[1];
          return this.nearestNeighbour(_initBndPair2, _Double.default.POSITIVE_INFINITY, k);
        }
      } else if (arguments.length === 3) {
        if ((0, _hasInterface.default)(arguments[2], _ItemDistance.default) && arguments[0] instanceof _Envelope.default && arguments[1] instanceof Object) {
          var env = arguments[0],
              item = arguments[1],
              _itemDist2 = arguments[2];
          var bnd = new _ItemBoundable.default(env, item);
          var bp = new _BoundablePair.default(this.getRoot(), bnd, _itemDist2);
          return this.nearestNeighbour(bp)[0];
        } else if (Number.isInteger(arguments[2]) && arguments[0] instanceof _BoundablePair.default && typeof arguments[1] === "number") {
          var _initBndPair3 = arguments[0],
              _maxDistance = arguments[1],
              _k = arguments[2];
          var distanceLowerBound = _maxDistance;
          var priQ = new _PriorityQueue.default();
          priQ.add(_initBndPair3);
          var kNearestNeighbors = new _PriorityQueue.default();

          while (!priQ.isEmpty() && distanceLowerBound >= 0.0) {
            var bndPair = priQ.poll();
            var currentDistance = bndPair.getDistance();

            if (currentDistance >= distanceLowerBound) {
              break;
            }

            if (bndPair.isLeaves()) {
              if (kNearestNeighbors.size() < _k) {
                kNearestNeighbors.add(bndPair);
              } else {
                var bp1 = kNearestNeighbors.peek();

                if (bp1.getDistance() > currentDistance) {
                  kNearestNeighbors.poll();
                  kNearestNeighbors.add(bndPair);
                }

                var bp2 = kNearestNeighbors.peek();
                distanceLowerBound = bp2.getDistance();
              }
            } else {
              bndPair.expandToQueue(priQ, distanceLowerBound);
            }
          }

          return STRtree.getItems(kNearestNeighbors);
        }
      } else if (arguments.length === 4) {
        var _env = arguments[0],
            _item = arguments[1],
            _itemDist3 = arguments[2],
            _k2 = arguments[3];
        var bnd = new _ItemBoundable.default(_env, _item);
        var bp = new _BoundablePair.default(this.getRoot(), bnd, _itemDist3);
        return this.nearestNeighbour(bp, _k2);
      }
    }
  }, {
    key: "getClass",
    value: function getClass() {
      return STRtree;
    }
  }, {
    key: "interfaces_",
    get: function get() {
      return [_SpatialIndex.default, _Serializable.default];
    }
  }], [{
    key: "centreX",
    value: function centreX(e) {
      return STRtree.avg(e.getMinX(), e.getMaxX());
    }
  }, {
    key: "avg",
    value: function avg(a, b) {
      return (a + b) / 2;
    }
  }, {
    key: "getItems",
    value: function getItems(kNearestNeighbors) {
      var items = new Array(kNearestNeighbors.size()).fill(null);
      var count = 0;

      while (!kNearestNeighbors.isEmpty()) {
        var bp = kNearestNeighbors.poll();
        items[count] = bp.getBoundable(0).getItem();
        count++;
      }

      return items;
    }
  }, {
    key: "centreY",
    value: function centreY(e) {
      return STRtree.avg(e.getMinY(), e.getMaxY());
    }
  }]);

  return STRtree;
}(_AbstractSTRtree2.default);

exports.default = STRtree;

var STRtreeNode =
/*#__PURE__*/
function (_AbstractNode) {
  _inherits(STRtreeNode, _AbstractNode);

  function STRtreeNode() {
    var _this2;

    _classCallCheck(this, STRtreeNode);

    _this2 = _possibleConstructorReturn(this, _getPrototypeOf(STRtreeNode).call(this));
    STRtreeNode.constructor_.apply(_assertThisInitialized(_this2), arguments);
    return _this2;
  }

  _createClass(STRtreeNode, [{
    key: "computeBounds",
    value: function computeBounds() {
      var bounds = null;

      for (var i = this.getChildBoundables().iterator(); i.hasNext();) {
        var childBoundable = i.next();

        if (bounds === null) {
          bounds = new _Envelope.default(childBoundable.getBounds());
        } else {
          bounds.expandToInclude(childBoundable.getBounds());
        }
      }

      return bounds;
    }
  }, {
    key: "getClass",
    value: function getClass() {
      return STRtreeNode;
    }
  }, {
    key: "interfaces_",
    get: function get() {
      return [];
    }
  }]);

  return STRtreeNode;
}(_AbstractNode2.default);

STRtreeNode.constructor_ = function () {
  var level = arguments[0];

  _AbstractNode2.default.constructor_.call(this, level);
};

STRtree.STRtreeNode = STRtreeNode;

STRtree.constructor_ = function () {
  if (arguments.length === 0) {
    STRtree.constructor_.call(this, STRtree.DEFAULT_NODE_CAPACITY);
  } else if (arguments.length === 1) {
    var nodeCapacity = arguments[0];

    _AbstractSTRtree2.default.constructor_.call(this, nodeCapacity);
  }
};

STRtree.serialVersionUID = 259274702368956900;
STRtree.xComparator = new (
/*#__PURE__*/
function () {
  function _class() {
    _classCallCheck(this, _class);
  }

  _createClass(_class, [{
    key: "compare",
    value: function compare(o1, o2) {
      return _AbstractSTRtree2.default.compareDoubles(STRtree.centreX(o1.getBounds()), STRtree.centreX(o2.getBounds()));
    }
  }, {
    key: "interfaces_",
    get: function get() {
      return [_Comparator.default];
    }
  }]);

  return _class;
}())();
STRtree.yComparator = new (
/*#__PURE__*/
function () {
  function _class2() {
    _classCallCheck(this, _class2);
  }

  _createClass(_class2, [{
    key: "compare",
    value: function compare(o1, o2) {
      return _AbstractSTRtree2.default.compareDoubles(STRtree.centreY(o1.getBounds()), STRtree.centreY(o2.getBounds()));
    }
  }, {
    key: "interfaces_",
    get: function get() {
      return [_Comparator.default];
    }
  }]);

  return _class2;
}())();
STRtree.intersectsOp = new (
/*#__PURE__*/
function () {
  function _class3() {
    _classCallCheck(this, _class3);
  }

  _createClass(_class3, [{
    key: "intersects",
    value: function intersects(aBounds, bBounds) {
      return aBounds.intersects(bBounds);
    }
  }, {
    key: "interfaces_",
    get: function get() {
      return [IntersectsOp];
    }
  }]);

  return _class3;
}())();
STRtree.DEFAULT_NODE_CAPACITY = 10;